'use strict';

import gsap from "gsap";

import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";


gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

class LifeAt3MediaPage {

    constructor($target) {

        $target;

        
        let downArrow = $target.find('.life_at_all3__btn_down')
        let bodyContent = $target.find('.life_at_all3__body')

        let heroTitle = $target.find('.life_at_all3__hero_title')
        let heroImage = $target.find('.life_at_all3__image_cont')
        let heroCopy = $target.find('.life_at_all3__copy p')

        let bodyTitle = $target.find('.block_paragraph_long__title')
        let bodyCopy = $target.find('.life_at_all3__body_copy')

        let animWideScreen = window.matchMedia("(min-width:992px)");
        let iPadScreen = window.matchMedia("(min-width:768px)");
        let onEnterHeroTimeline = gsap.timeline({repeat: 0, repeatDelay: 0 });
        let onEnterBodyTimeline = gsap.timeline({repeat: 0, repeatDelay: 0 });

        var distance = $('.life_at_all3__body').offset().top;

        if(animWideScreen.matches){
            gsap.set([bodyTitle, bodyCopy] , {opacity:0, y:80});
        }
        function init(){

            scrollFromHero();
            $(window).on('load', animateHero());

            $(window).on("scroll", function() {
                if ( $(window).scrollTop() >= distance ) {
                    animateBody();
                }
            });


        
        }

       function scrollFromHero(){
            var topPos = 0;
            if(!iPadScreen.matches){
                topPos = $(bodyContent).offset().top + 100
            }else{
                // topPos = $(bodyContent).offset().top
            }
            $(downArrow).click(function() {
                $('html, body').animate({
                    scrollTop: $(bodyContent).offset().top
                }, 1000);
            });
        }

        function animateHero(){

            if(animWideScreen.matches){
                
                gsap.set(heroTitle, {opacity:0,  y: - 20});
                gsap.set(heroCopy, {opacity:0,  x: 20});
                gsap.set(heroImage, {opacity:0,  x: - 20});
                gsap.set(downArrow , {opacity:0,  y: - 20})
    
                onEnterHeroTimeline.to(heroTitle,  {delay: 0,  duration: 0.8, y: 0, opacity:1})
                onEnterHeroTimeline.to(heroImage,  {delay: -0.5,  duration: 0.8, x: 0, opacity:1})
                onEnterHeroTimeline.to(heroCopy, {delay: -0.5,  duration: 0.8, x: 0, opacity:1, stagger: 0.08})
                onEnterHeroTimeline.to(downArrow, {delay: -0.5,  duration: 0.8, x: 0, opacity:1, y:0})
            
            }
           
        }

        function animateBody(){

            if(animWideScreen.matches){
              
                onEnterBodyTimeline.to([bodyTitle, bodyCopy], {delay:-0.3, duration:0.8, opacity:1, y:0, stagger:0.08});
             
            }
           
        }

        init();

        return {
            publicLifeAt3MediaPage: function (string) {

            }
        }

    }

}
    
export default LifeAt3MediaPage;